import React, { useEffect } from 'react';
import { updatePageTitle } from "../../../modules/legacyUtils";
import { trackEvent } from "../../../modules/tracking";
import { AnalyticsEvents } from "../../../modules/analyticsEvents";
import ReviewForm from "../../interactive/ReviewForm";
export default function ReviewTimelinesIndex({ eligibleForQualificationChecks }) { updatePageTitle('Review and confirm'); useEffect(() => { trackEvent(AnalyticsEvents.screenViews.review()); }, []); return /*#__PURE__*/ React.createElement(ReviewForm, { eligibleForQualificationChecks: eligibleForQualificationChecks }); }
